import { Component, Inject, OnInit } from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';

import { ISerieFiscal } from '@app/modules/serie-fiscal/model/serie_fiscal.model';
import { SerieFiscalService } from '@app/modules/serie-fiscal/services/serie_fiscal.service';
import { SELECT } from '@app/shared/components';

@Component({
  selector: 'app-fast-serie-fiscal',
  templateUrl: './fast-serie-fiscal.component.html',
  styleUrls: ['./fast-serie-fiscal.component.scss'],
  providers: [SerieFiscalService]
})
export class FastSerieFiscalComponent implements OnInit {
  form: UntypedFormGroup;

  loading = false;
  entity: ISerieFiscal;

  displayMessages = {
    modelo: {
      required: 'O modelo é obrigatório'
    },
    serie: {
      required: 'A série é obrigatória',
      max: 'Limite de 999 números',
      existSpecialChar: 'Valor inválido, não aceita pontuação!'
      // before_split: 'Inválido: erro na parte inteira',
      // after_split: 'Inválido: erro na parte decimal',
      // errorComma: 'Inválido: excesso de virgulas',
      // errorDots: 'Inválido: excesso de pontos',
      // max_value: 'Inválido: passou dos limites',
      // notNumbers: 'Inválido: insira um número',
      // invalidNumber: 'Valor inválido'
    },
    ultimo_doc: {
      required: 'O úlitmo documento é obrigatório',
      maxlength: 'Limite de 15 caracteres',
      existSpecialChar: 'Valor inválido, não aceita pontuação!'
      // before_split: 'Inválido: erro na parte inteira',
      // after_split: 'Inválido: erro na parte decimal',
      // errorComma: 'Inválido: excesso de virgulas',
      // errorDots: 'Inválido: excesso de pontos',
      // max_value: 'Inválido: passou dos limites',
      // notNumbers: 'Inválido: insira um número',
      // invalidNumber: 'Valor inválido'
    },
    ambiente: {
      required: 'O ambiente é obrigatório'
    },
    status: {
      required: 'O status é obrigatório'
    }
  };

  tiposModelo = [
    { viewValue: '55 - NFe', value: 'NFE' },
    { viewValue: '65 - NFCe', value: 'NFCE' }
  ] as SELECT[];

  tiposAmbiente = [
    { viewValue: '1 - Homologação', value: 'HOMOLOGACAO' },
    { viewValue: '2 - Produção', value: 'PRODUCAO' }
  ] as SELECT[];

  tipoStatus = [
    { viewValue: 'Ativo', value: 'ATIVO' }
    // { viewValue: 'Inativo', value: 'INATIVO' }
  ] as SELECT[];

  constructor(
    public dialogRef: MatDialogRef<FastSerieFiscalComponent>,
    private formBuilder: UntypedFormBuilder,
    public entityService: SerieFiscalService,
    public tokenService: TokenService,
    public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) private data: { entity: ISerieFiscal }
  ) {}

  ngOnInit(): void {
    this.entity = this.data.entity;
    this.form = this.formBuilder.group({
      modelo: [
        this.entity.modelo
          ? this.tiposModelo.find(tp => tp.value === this.entity.modelo.toString())
          : this.tiposModelo[1],
        [Validators.required]
      ],
      serie: [
        this.entity.serie,
        [
          Validators.required,
          Validators.max(999),
          CustomValidators.existSpecialChar(),
          // CustomValidators.validateCurrencyValues(15,2)
        ]
      ],
      ultimo_doc: [
        0, //this.entity.ultimo_doc
        [
          Validators.required,
          Validators.maxLength(15),
          CustomValidators.existSpecialChar(),
          // CustomValidators.validateCurrencyValues(15,2)
        ]
      ],
      ambiente: [
        this.entity.ambiente
          ? this.tiposAmbiente.find(tp => tp.value === this.entity.ambiente)
          : this.tiposAmbiente[0],
        [Validators.required]
      ],
      status: [this.tipoStatus[0], [Validators.required]]
    });

    this.markAllControlsAsDirty();
  }

  public submit(): void {
    if (!this.form.valid) return;

    this.loading = true;
    const { value } = this.form;
    const entity = {
      domain_org_id: this.tokenService.getDomain().id,
      ...value
    };

    entity.modelo = value.modelo.value;
    entity.ambiente = value.ambiente.value;
    entity.status = value.status.value;
    if (entity.numero_modelo) delete entity.numero_modelo;

    this.entityService.insert(entity).subscribe(
      serie => {
        if (serie) {
          this.matSnackBar.open(`Série fiscal cadastrada com sucesso.`, 'X', {
            duration: 2000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['msg-success']
          });
          this.dialogRef.close(serie);
        }
      },
      () => {
        this.matSnackBar.open(`Erro ao cadastrar série fiscal.`, 'X', {
          duration: 2000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['msg-error']
        });
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  markAllControlsAsDirty() {
    Object.keys(this.form.controls).forEach(controlKey => {
      controlKey = String(controlKey);
      const control = this.form.get(controlKey);
      if (!control || control.valid) return;
      control.markAsDirty();
    });
  }

  validateNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }
}
